module.exports = __webpack_public_path__ + "static/media/IMG_6252.70e2eb1d.JPG";